import { INativeViewerArtifactsReady } from './INativeViewerArtifacts';

/**
 * O que a PONTE do motor consome (espelha `apps/coordly-embed/src/types.ts`).
 * Não é o contrato da API: a resposta do backend (`INativeViewerArtifacts`) é
 * traduzida para cá em `toIfcArtifacts`, e só o adaptador passa isto adiante.
 *
 * `split` é o layout de produção — 3 parquets lidos por range request. O
 * `container` (arquivo concatenado) fica pelos artefatos antigos da POC.
 */
export interface IIfcGeometryContainer {
  layout: 'container';
  geometry: string;
}

export interface IIfcGeometrySplit {
  layout: 'split';
  mesh: string;
  vertex: string;
  index: string;
}

export type IIfcGeometryUrls = IIfcGeometryContainer | IIfcGeometrySplit;

export interface IIfcArtifactUrls {
  geometry: IIfcGeometryUrls;
  metadata: string;
  datamodel?: string;
  symbolic?: string;
}

export interface IIfcArtifacts {
  status: 'ready';
  urls: IIfcArtifactUrls;
}

export const toIfcArtifacts = ({ Artifacts: artifacts }: INativeViewerArtifactsReady): IIfcArtifacts => ({
  status: 'ready',
  urls: {
    geometry: {
      layout: 'split',
      mesh: artifacts.mesh,
      vertex: artifacts.vertex,
      index: artifacts.index,
    },
    metadata: artifacts.metadata,
    datamodel: artifacts.dataModel,
    symbolic: artifacts.symbolic,
  },
});
